// extracted by mini-css-extract-plugin
module.exports = {"desktopWidth":"1024px","gapExtraSmall":".45rem","gapLarge":".9rem","root":"ChatView_root__2nRj_","actions":"ChatView_actions__2Rw2e","btn-expand":"ChatView_btn-expand__3yKqY"};